import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, X, Loader2, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

const EmailVerificationBanner = ({ user, onClose }) => {
  const [resending, setResending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setResending(true);
    try {
      await axios.post('/auth/resend-verification', {
        email: user.email,
        user_type: user.user_type
      });
      toast.success('Email di verifica inviata! Controlla la tua casella di posta.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Errore nell\'invio');
    } finally {
      setResending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) onClose();
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm text-amber-800">
                <strong>Verifica la tua email</strong> - Controlla la tua casella di posta per confermare il tuo indirizzo email.
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleResend}
              disabled={resending}
              className="border-amber-300 text-amber-700 hover:bg-amber-100"
            >
              {resending ? (
                <><Loader2 className="h-3 w-3 mr-1 animate-spin" /> Invio...</>
              ) : (
                <><Mail className="h-3 w-3 mr-1" /> Rinvia Email</>
              )}
            </Button>
            <button
              onClick={handleDismiss}
              className="p-1 text-amber-600 hover:text-amber-800 rounded"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
